<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Visualização de Provedor Biométrico" />
    <v-row justify="center" align="center">
      <v-col>
        <form-biometric-provider
          v-if="model"
          v-model="model"
          :readonly="true"
        />
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import { onMounted, ref, Ref } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import FormBiometricProvider from './form-biometric-provider.vue'
import type { BiometricProvider } from '@/types/BiometricProvider'
import BiometricProviderService from '@/services/BiometricProviderService'
import { useLoader } from '@/stores/loader'
import { useRoute } from 'vue-router'
import { useSnackBar } from '@/stores/snackbar'

const loader = useLoader()
const route = useRoute()
const snackbar = useSnackBar()

const model: Ref<BiometricProvider> = ref({} as BiometricProvider)

async function fetch() {
  try {
    loader.increment()
    const response = await (new BiometricProviderService()).show(route.params.id as string)
    model.value = response.data.data
  } catch (error) {
    snackbar.show(
      'Não foi possível buscar o provedor biométrico',
      'error',
    )

    throw error
  } finally {
    loader.decrement()
  }
}

onMounted(() => fetch())
</script>
